var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-image__preview"},_vm._l((_vm.tValue),function(item){return _c('el-link',{key:item,staticClass:"el-icon-document",attrs:{"href":item,"target":"_blank"}},[_vm._v(_vm._s(item))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }